import differenceInSeconds from 'date-fns/differenceInSeconds';
import parseISO from 'date-fns/parseISO';

export const STATUS = {
  upcoming: 'upcoming',
  open: 'open',
  pastDueDate: 'pastDueDate',
  nearDueDate: 'nearDueDate',
  closed: 'closed',
  submitted: 'submitted',
  submittedLate: 'submittedLate',
  notSubmitted: 'notSubmitted',
  manualAssignment: 'manualAssignment',
};

type AssignmentDates = {
  startDate?: string;
  endDate?: string;
  status: string;
  shouldCloseOnDueDate?: boolean;
};

export const getStatus = ({
  startDate,
  endDate,
  status,
  shouldCloseOnDueDate,
}: AssignmentDates) => {
  if (status === STATUS.closed) {
    return status;
  }

  if (!startDate || !endDate) {
    return null;
  }

  const now = new Date();
  const diffStartInSeconds = differenceInSeconds(parseISO(startDate), now);
  const diffDueInSeconds = differenceInSeconds(parseISO(endDate), now);

  if (diffStartInSeconds > 0) {
    return STATUS.upcoming;
  }

  if (diffDueInSeconds > 604800) {
    return STATUS.open;
  }

  if (diffDueInSeconds > 0) {
    return STATUS.nearDueDate;
  }

  if (shouldCloseOnDueDate) {
    return STATUS.closed;
  }

  return STATUS.pastDueDate;
};

export const getStatusLabel = (status: string) => {
  switch (status) {
    case STATUS.upcoming:
      return 'Upcoming';
    case STATUS.open:
    case STATUS.nearDueDate:
      return 'Open';
    case STATUS.pastDueDate:
      return 'Past due date';
    case STATUS.closed:
      return 'Closed';
    case STATUS.submitted:
      return 'Submitted';
    case STATUS.submittedLate:
      return 'Submitted Late';
    case STATUS.notSubmitted:
      return 'Not Submitted';
    case STATUS.manualAssignment:
      return 'Manual assignment';
    default:
      return status;
  }
};

export const getStatusStyles = (status: string, isDark: boolean = false) => {
  switch (status) {
    case STATUS.upcoming:
      return {
        backgroundColor: isDark ? '#0E90B2' : '#0E90B2',
        color: '#FFFFFF',
      };
    case STATUS.open:
      return {
        backgroundColor: isDark ? '#4FC3F7' : '#03A9F4',
      };
    case STATUS.nearDueDate:
      return {
        backgroundColor: isDark ? '#FFA726' : '#EF6C00',
      };
    case STATUS.pastDueDate:
      return {
        backgroundColor: '#78909C',
        color: '#FFFFFF',
      };
    case STATUS.closed:
      return {
        backgroundColor: isDark ? '#E57373' : '#EF5350',
        color: '#FFFFFF',
      };
    case STATUS.manualAssignment:
      return {
        backgroundColor: '#746887',
        color: '#FFFFFF',
      };
  }
};
